export default __webpack_public_path__ + "static/media/Manager.0e0b3222.svg";